/**
 * 金流 API client — 街口支付 OnlinePay
 */
import { api } from "./client";

// 哪些付款方式對目前會員開放(UAT 期間只有測試名單看得到街口)
export async function getPaymentMethods(): Promise<{ jkopay: boolean }> {
  const { data } = await api.get("/api/payments/methods");
  return data;
}

export interface JkopayCheckoutResult {
  status: string; // ok / already_paid / not_payable / forbidden / jkopay_unavailable / entry_failed
  payment_url?: string;
  qr_img?: string;
  qr_timeout?: number;
  order_status?: string; // not_payable 時附帶訂單目前狀態
}

/**
 * 街口也用 4xx 傳「為什麼不能付」—— not_payable / forbidden / jkopay_unavailable 等。
 * axios 預設把 4xx 丟成例外,呼叫端只會顯示「請稍後再試」,可是這幾種再試一百次也不會成功
 * (訂單取消了、不是你的單、街口沒對你開放)。跟 gifts.ts 同一個病,2026-09-16 一起補。
 *
 * 502(entry_failed)刻意**不**放行 —— 那是街口端真的掛了,「稍後再試」才是對的話。
 */
const PASS_4XX = (s: number) => (s >= 200 && s < 300) || s === 400 || s === 403 || s === 404;

/** 街口錯誤碼 → 講人話。看不懂的碼一律退回「稍後再試」。 */
export function jkopayErrorText(r: JkopayCheckoutResult): string {
  switch (r.status) {
    case "not_found":
      return "找不到這筆訂單";
    case "forbidden":
      return "這筆訂單不屬於您的帳號";
    case "not_jkopay_order":
      return "這筆訂單不是用街口付款的";
    case "not_payable":
      return r.order_status === "cancelled"
        ? "這筆訂單已取消,無法付款"
        : "這筆訂單目前無法付款,請與專屬顧問聯繫";
    case "jkopay_unavailable":
      return "街口付款目前未對您的帳號開放";
    default:
      return "取得付款連結失敗,請稍後再試";
  }
}

// 對一筆待付款訂單取街口付款網址(20 分鐘失效,失效重打同一支續期)
export async function jkopayCheckout(order_id: string): Promise<JkopayCheckoutResult> {
  const { data } = await api.post("/api/payments/jkopay/checkout", { order_id }, {
    validateStatus: PASS_4XX,
  });
  return data;
}
